//-------------------------- verification  -------------------------- //

window.stepCheck = {}

stepCheck.stepOne = async function (stepSelected, with_error, with_target) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'address') {
        const address = stepElement.querySelector('#address')

        if (address.value.length === 0) {
            error = true
        } else {
            if (hasAddressDetails() === false) {
                error = true
            }
        }

        toggleInputError(address, stepElement, !error, with_error)
    }

    if (with_target == null || with_target === 'monthly_electric_bill') {
        const monthly_electric_bill = stepElement.querySelector('#monthly_electric_bill')

        if (monthly_electric_bill.value <= 0) {
            error = true

            toggleInputError(monthly_electric_bill, stepElement, false, with_error)
        } else {
            toggleInputError(monthly_electric_bill, stepElement, true, with_error)
        }
    }

    return error
}

//-------------------------- binds  -------------------------- //

window.setupBind = {}

setupBind.stepOne = function (stepElement, stepKey) {
    let idsOne = ['address', 'monthly_electric_bill']

    //address
    let inputAddress = stepElement.querySelector('#address')

    inputAddress.addEventListener('keyup', async (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        await stepCheck.stepOne(stepKey, false, 'address')

        let is_disabled = stepInputValid(idsOne) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputAddress.addEventListener('keyup', async (event) => {
        await stepCheck.stepOne(stepKey, false, 'address')

        let is_disabled = stepInputValid(idsOne) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    //monthly_electric_bill
    let inputMonthlyElectricBill = stepElement.querySelector('#monthly_electric_bill')

    inputMonthlyElectricBill.addEventListener('keyup', async (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        await stepCheck.stepOne(stepKey, false, 'monthly_electric_bill')

        let is_disabled = stepInputValid(idsOne) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputMonthlyElectricBill.addEventListener('keyup', async (event) => {
        await stepCheck.stepOne(stepKey, false, 'monthly_electric_bill')

        let is_disabled = stepInputValid(idsOne) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

//-------------------------- form  -------------------------- //

stepShowRules = function (stepSelected) {
    return stepSelected
}

submitHandle = function (button) {
    const form = button.form
    const formData = new FormData(form)

    switch (options.formSubmit) {
        default:
            window.history.pushState({}, null, options.resultsURL)

            stepNextButtonLoading(button, false) //this actually disable overlay

            document.querySelector('#form-container').remove()
            document.querySelector('#loader-container').style.display = 'block'
            setLoadingMobile()

            loadScript('https://www.gstatic.com/charts/loader.js', () => {
                setTimeout( () => {
                    //process
                    fetch(options.processURL, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: formData,
                        mode: 'cors',
                        header: {
                            'Access-Control-Allow-Origin': '*',
                        }
                    })
                    .then((result) => result.json())
                    .then((result) => {
                        document.querySelector('#loader-container').remove()
                        document.querySelector('#results-container').style.display = 'block'
                        document.querySelector('#results-container').innerHTML = result.html

                        setupSticky()
                        setupResults(result.graph.period, result.graph.savings)

                        if (mdrvConfigData.environment === 'production') {
                            googleTriggerEvent('CalculatorFormSubmit')
                        }
                    })
                    .catch(() => {
                        alert('An error occurred during form process. Please refresh page and try again!')
                    })
                }, 3000)
            })
            break;
    }
}
